// Helpers compartilhados da CAMADA MOCK.
// ⚠️ Tudo aqui é temporário: simula latência de rede com Promise + setTimeout.
// FUTURO: substituir o corpo dos services por fetch() reais sem mudar as assinaturas.

export const delay = (ms = 400) => new Promise<void>((r) => setTimeout(r, ms));

// Clona profundamente para isolar o "store em memória" das referências dos componentes.
export function clone<T>(value: T): T {
  return structuredClone(value);
}
